"use client";

import { useEffect } from "react";
import Button from "@lib/ui/components/Button";
import Image from "next/image";
import Link from "next/link";
import { Inter } from "next/font/google";

const inter = Inter({ subsets: ["latin"] });

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <div className={`${inter.className} min-h-screen homeGradientBg px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8`}>
      <div className="absolute left-4 top-4 md:left-8 md:top-8">
        <Link href="/">
          <Image src="/imgs/new_icon_white.png" width={180} height={180} alt="MedEngine Logo" className="md:block" />
        </Link>
      </div>
      <div className="mx-auto max-w-max">
        <main className="flex items-center sm:items-center">
          <div className="flex-shrink-0">
            <div className="relative h-16 w-16 sm:h-24 sm:w-24">
              {/* <Image
                src="/imgs/icons/alert-red.svg"
                alt="Error"
                fill
                className="object-contain"
              /> */}
            </div>
          </div>
          <div className="sm:ml-6">
            <div className="sm:border-l sm:border-gray-200 sm:pl-6">
              <h1 className="text-4xl font-bold tracking-tight text-primaryWhite sm:text-5xl">
                Something went wrong!
              </h1>
              <p className="mt-3 text-base text-SecondaryWhite">
                We apologize for the inconvenience. Please try again or contact support if the problem persists.
              </p>
            </div>
            <div className="mt-6 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6">
              <Button
                onClick={reset}
                className="inline-flex items-center bg-SecondaryBlue hover:bg-opacity-90"
              >
                Try again
              </Button>
              <Link href="/">
                <Button
                  variant="secondary"
                  className="inline-flex items-center border border-primaryWhite text-primaryWhite hover:bg-primaryWhite hover:bg-opacity-10"
                >
                  Go back home
                </Button>
              </Link>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
} 